import { ApiService } from "../../../service/ApiService";

import { StoreActions } from "../../../store/actions";
import { FreeProxyAction } from "../../../store/freeProxy/freeProxySlice";

import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import { useGetProxies } from "../../../hooks";

import { Seo } from "../../../components/Seo/Seo";
import { Faq } from "../../../components/common/Faq/Faq";
import { Head } from "./components/Head/Head";
import { Table } from "./components/Table/Table";

const FreeProxyServer = () => {
  useGetProxies();

  return (
    <>
      <Head />
      <Table />
      <Faq />
      <Seo />
    </>
  );
};

FreeProxyServer.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);

  const page = Number(params.params.page || "1") - 1;

  const cityName = params?.params?.city
    ? decodeURIComponent(params.params.country)
    : "";
  const englishCountryName = params?.params?.country
    ? decodeURIComponent(params.params.country)
    : "";

  const fetchParams = {
    cityName,
    englishCountryName,
    google: params.params.google || "",
    page,
    proxyType: params.params.type || "",
    size: 10,
  };

  if (englishCountryName) {
    const country = englishCountryName;
    const lang = params.locale;

    try {
      const { data } = await ApiService.getCountryInfo(country, lang);

      if (data) {
        store.dispatch(StoreActions.saveCountryInfo(data));
      }
    } catch (e) {
      console.log(
        "FreeProxyServer: Error in fetching country info, ",
        e.message,
      );
    }
  }

  try {
    const proxies = await ApiService.getProxyServers(fetchParams);
    const paginationData =
      await ApiService.getPaginationProxyServers(fetchParams);

    if (proxies) {
      store.dispatch(FreeProxyAction.serverProxySave(proxies));
    }

    if (paginationData) {
      store.dispatch(FreeProxyAction.paginationProxySave(paginationData));
    }
  } catch (e) {
    console.log(
      "FreeProxyServer: Error in fetch proxies or pagination, ",
      e.message,
    );
  }
};

export default FreeProxyServer;
